// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* components/Header.css */

/* ヘッダーの自動高さ化 + 左右パディングをタイトに */
.app-header-autosize .cds--header {
  height: auto;
  min-height: 3rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 1rem;
  padding-right: 0.75rem;
  align-items: center;
  position: relative; /* 中央タイトルの絶対配置に必要 */
}

/* 内側にフック用クラス */
.app-header-inner { position: relative; }

/* Carbonのデフォで HeaderName に margin-left が入るので除去 */
.app-header-autosize .cds--header__name {
  margin-left: 0 !important;
  padding-left: 0 !important;
}

/* タイトルのパーツ折返し（区切りでのみ改行） */
.title-chunks {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0;
  line-height: 1.25;
}
.title-chunk { white-space: nowrap; }
.title-chunk + .title-chunk { margin-left: 0.25rem; }
.title-chunk + .title-chunk::before { content: "｜"; margin-right: 0.25rem; }

/* ─────────────────────────────────────────
   ヘッダー内のリンク（患者一覧/ダッシュボード/ログアウト）
   ───────────────────────────────────────── */
.app-header-link {
  color: inherit;
  text-decoration: none;
  font-weight: 600;
  padding: 0.375rem 0.5rem;
  border-radius: 4px;
  display: inline-flex;          /* ← フレックスで縦中央 */
  align-items: center;           /* ← アイコン/文字の縦中央揃え */
  gap: 8px;
  height: 2rem;                  /* 視覚的高さを固定 */
  line-height: 1;                /* ベースラインのズレを消す */
  white-space: nowrap;           /* ← ②: 改行しない */
  min-width: 0;                  /* ← ②: 念のため（Flex子の溢れ対策） */
}
button.app-header-link {
  background: transparent;
  border: none;
  cursor: pointer;
}
.app-header-link:hover {
  background: rgba(0,0,0,0.06);
}
/* アイコンの縦ズレ対策：block化 + サイズ固定 */
.app-header-link svg {
  display: block;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
}
.app-header-link span {
  display: block;                /* テキストも block にして揃える */
  font-size: 1rem;               /* 16px */
  line-height: 1.25;
  white-space: nowrap;           /* ← ②: 改行しない（念のため） */
}

/* ─────────────────────────────────────────
   ★ PCで中央に置くタイトル（左アクションがある時のみ）
   ───────────────────────────────────────── */
.app-header-centerTitle {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-weight: 600;
  text-align: center;
  max-width: min(70vw, 1200px);
  padding: 0 0.5rem;
  -webkit-user-select: none;
          user-select: none;
  font-size: 1rem;               /* タイトルも 16px に統一 */
  line-height: 1.25;
}

/* PCかつ左アクションがある時だけ、左のHeaderNameを不可視化して幅は保持 */
@media (min-width: 1025px) {
  .app-header-left[data-left-actions="1"] .app-header-titleLeft { visibility: hidden; }
}

/* モバイル時は中央固定タイトルを消して、左の通常タイトルを表示 */
@media (max-width: 1024px) {
  .app-header-centerTitle { display: none; }
  .app-header-autosize .cds--header {
    padding-left: 0.375rem;
    padding-right: 0.5rem;
  }
  .title-chunks {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

/* モバイルのメニュー用ボタン（右パネル） */
.app-header-menu-btn {
  display: flex;
  align-items: center;           /* ← 中央揃え */
  gap: 8px;
  padding: 0.75rem;
  text-align: left;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fff;
  font-weight: 600;
  cursor: pointer;

  min-height: 44px;              /* タップ領域の確保 */
  line-height: 1;                /* ベースラインのズレを消す */
  white-space: nowrap;           /* ← ②: 改行しない */
  min-width: 0;                  /* ← ②: 念のため */
}
.app-header-menu-btn svg {
  display: block;                /* ← inline をやめて縦ズレ防止 */
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
}
.app-header-menu-btn span {
  display: block;
  font-size: 1rem;
  line-height: 1.25;
  white-space: nowrap;           /* ← ②: 改行しない（念のため） */
}

/* モバイル：左アクションが無い時はタイトル頭に少しだけ余白を足す */
@media (max-width: 1024px) {
  .app-header-left[data-left-actions="0"] .cds--header__name {
    margin-left: 0.5rem !important;
  }
}

/* ダッシュボード（リンク/ボタン）を青に（アイコンも含めて） */
.app-header-link--dashboard { color: #0f62fe; }
.app-header-link--dashboard:hover { background: rgba(15, 98, 254, 0.08); }
.app-header-menu-btn--dashboard {
  color: #0f62fe;
  border-color: rgba(15, 98, 254, 0.25);
}
.app-header-menu-btn--dashboard:hover { background: rgba(15, 98, 254, 0.06); }

/* ログアウトリンク（PC） */
.app-header-logout { font-weight: 600; }

/* 左のタイトル（HeaderName）の本文サイズも揃える */
.app-header-titleLeft .title-chunks {
  font-size: 1rem;
  line-height: 1.25;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B,8BAA8B;AAC9B;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB,EAAE,mBAAmB;AACzC;;AAEA,eAAe;AACf,oBAAoB,kBAAkB,EAAE;;AAExC,iDAAiD;AACjD;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,MAAM;EACN,iBAAiB;AACnB;AACA,eAAe,mBAAmB,EAAE;AACpC,8BAA8B,oBAAoB,EAAE;AACpD,sCAAsC,YAAY,EAAE,qBAAqB,EAAE;;AAE3E;;8CAE8C;AAC9C;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB,WAAW,gBAAgB;EAC/C,mBAAmB,YAAY,oBAAoB;EACnD,QAAQ;EACR,YAAY,mBAAmB,aAAa;EAC5C,cAAc,iBAAiB,iBAAiB;EAChD,mBAAmB,YAAY,eAAe;EAC9C,YAAY,mBAAmB,0BAA0B;AAC3D;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA,8BAA8B;AAC9B;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc,iBAAiB,uBAAuB;EACtD,eAAe,gBAAgB,SAAS;EACxC,iBAAiB;EACjB,mBAAmB,YAAY,qBAAqB;AACtD;;AAEA;;8CAE8C;AAC9C;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe,gBAAgB,mBAAmB;EAClD,iBAAiB;AACnB;;AAEA,6CAA6C;AAC7C;EACE,gEAAgE,kBAAkB,EAAE;AACtF;;AAEA,mCAAmC;AACnC;EACE,0BAA0B,aAAa,EAAE;EACzC;IACE,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;EAClB;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB,YAAY,WAAW;EAC1C,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;;EAEf,gBAAgB,eAAe,aAAa;EAC5C,cAAc,iBAAiB,iBAAiB;EAChD,mBAAmB,YAAY,eAAe;EAC9C,YAAY,mBAAmB,cAAc;AAC/C;AACA;EACE,cAAc,iBAAiB,uBAAuB;EACtD,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB,YAAY,qBAAqB;AACtD;;AAEA,oCAAoC;AACpC;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA,kCAAkC;AAClC,8BAA8B,cAAc,EAAE;AAC9C,oCAAoC,mCAAmC,EAAE;AACzE;EACE,cAAc;EACd,qCAAqC;AACvC;AACA,wCAAwC,mCAAmC,EAAE;;AAE7E,iBAAiB;AACjB,qBAAqB,gBAAgB,EAAE;;AAEvC,iCAAiC;AACjC;EACE,eAAe;EACf,iBAAiB;AACnB","sourcesContent":["/* components/Header.css */\n\n/* ヘッダーの自動高さ化 + 左右パディングをタイトに */\n.app-header-autosize .cds--header {\n  height: auto;\n  min-height: 3rem;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 1rem;\n  padding-right: 0.75rem;\n  align-items: center;\n  position: relative; /* 中央タイトルの絶対配置に必要 */\n}\n\n/* 内側にフック用クラス */\n.app-header-inner { position: relative; }\n\n/* Carbonのデフォで HeaderName に margin-left が入るので除去 */\n.app-header-autosize .cds--header__name {\n  margin-left: 0 !important;\n  padding-left: 0 !important;\n}\n\n/* タイトルのパーツ折返し（区切りでのみ改行） */\n.title-chunks {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0;\n  line-height: 1.25;\n}\n.title-chunk { white-space: nowrap; }\n.title-chunk + .title-chunk { margin-left: 0.25rem; }\n.title-chunk + .title-chunk::before { content: \"｜\"; margin-right: 0.25rem; }\n\n/* ─────────────────────────────────────────\n   ヘッダー内のリンク（患者一覧/ダッシュボード/ログアウト）\n   ───────────────────────────────────────── */\n.app-header-link {\n  color: inherit;\n  text-decoration: none;\n  font-weight: 600;\n  padding: 0.375rem 0.5rem;\n  border-radius: 4px;\n  display: inline-flex;          /* ← フレックスで縦中央 */\n  align-items: center;           /* ← アイコン/文字の縦中央揃え */\n  gap: 8px;\n  height: 2rem;                  /* 視覚的高さを固定 */\n  line-height: 1;                /* ベースラインのズレを消す */\n  white-space: nowrap;           /* ← ②: 改行しない */\n  min-width: 0;                  /* ← ②: 念のため（Flex子の溢れ対策） */\n}\nbutton.app-header-link {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n.app-header-link:hover {\n  background: rgba(0,0,0,0.06);\n}\n/* アイコンの縦ズレ対策：block化 + サイズ固定 */\n.app-header-link svg {\n  display: block;\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n}\n.app-header-link span {\n  display: block;                /* テキストも block にして揃える */\n  font-size: 1rem;               /* 16px */\n  line-height: 1.25;\n  white-space: nowrap;           /* ← ②: 改行しない（念のため） */\n}\n\n/* ─────────────────────────────────────────\n   ★ PCで中央に置くタイトル（左アクションがある時のみ）\n   ───────────────────────────────────────── */\n.app-header-centerTitle {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-weight: 600;\n  text-align: center;\n  max-width: min(70vw, 1200px);\n  padding: 0 0.5rem;\n  user-select: none;\n  font-size: 1rem;               /* タイトルも 16px に統一 */\n  line-height: 1.25;\n}\n\n/* PCかつ左アクションがある時だけ、左のHeaderNameを不可視化して幅は保持 */\n@media (min-width: 1025px) {\n  .app-header-left[data-left-actions=\"1\"] .app-header-titleLeft { visibility: hidden; }\n}\n\n/* モバイル時は中央固定タイトルを消して、左の通常タイトルを表示 */\n@media (max-width: 1024px) {\n  .app-header-centerTitle { display: none; }\n  .app-header-autosize .cds--header {\n    padding-left: 0.375rem;\n    padding-right: 0.5rem;\n  }\n  .title-chunks {\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n}\n\n/* モバイルのメニュー用ボタン（右パネル） */\n.app-header-menu-btn {\n  display: flex;\n  align-items: center;           /* ← 中央揃え */\n  gap: 8px;\n  padding: 0.75rem;\n  text-align: left;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  background: #fff;\n  font-weight: 600;\n  cursor: pointer;\n\n  min-height: 44px;              /* タップ領域の確保 */\n  line-height: 1;                /* ベースラインのズレを消す */\n  white-space: nowrap;           /* ← ②: 改行しない */\n  min-width: 0;                  /* ← ②: 念のため */\n}\n.app-header-menu-btn svg {\n  display: block;                /* ← inline をやめて縦ズレ防止 */\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n}\n.app-header-menu-btn span {\n  display: block;\n  font-size: 1rem;\n  line-height: 1.25;\n  white-space: nowrap;           /* ← ②: 改行しない（念のため） */\n}\n\n/* モバイル：左アクションが無い時はタイトル頭に少しだけ余白を足す */\n@media (max-width: 1024px) {\n  .app-header-left[data-left-actions=\"0\"] .cds--header__name {\n    margin-left: 0.5rem !important;\n  }\n}\n\n/* ダッシュボード（リンク/ボタン）を青に（アイコンも含めて） */\n.app-header-link--dashboard { color: #0f62fe; }\n.app-header-link--dashboard:hover { background: rgba(15, 98, 254, 0.08); }\n.app-header-menu-btn--dashboard {\n  color: #0f62fe;\n  border-color: rgba(15, 98, 254, 0.25);\n}\n.app-header-menu-btn--dashboard:hover { background: rgba(15, 98, 254, 0.06); }\n\n/* ログアウトリンク（PC） */\n.app-header-logout { font-weight: 600; }\n\n/* 左のタイトル（HeaderName）の本文サイズも揃える */\n.app-header-titleLeft .title-chunks {\n  font-size: 1rem;\n  line-height: 1.25;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
